import apiV2, { apiV1 } from "api-v2";
import { isNotNullOrUndefined } from "newui/utils/objectUtil";

export const getDocumentCategories = async (
	excludingProfileTypeId: number | null
) => {
	try {
		const apiUrl = `document-categories${isNotNullOrUndefined(excludingProfileTypeId) ? `?filter[exclude_from_profile_id]=${excludingProfileTypeId}` : ""}`;
		const { data: categories } = await apiV1.get(apiUrl);
		return categories.data;
	} catch (err) {
		throw new Error(err?.response?.data?.message);
	}
};

export const getCompanyProfileTypes = async () => {
	try {
		const { data: profileTypes } = await apiV1.get("profile-types");
		return profileTypes.data;
	} catch (err) {
		throw new Error(err?.response?.data?.message);
	}
};

export const getProcurementMethods = async () => {
	try {
		const { data: procurementMethods } = await apiV1.get("procurement-methods");
		return procurementMethods.data;
	} catch (err) {
		throw new Error(err?.response?.data?.message);
	}
};

export const getSectors = async (companyId: number | null = null) => {
	try {
		const apiUrl = `sectors${companyId ? `?company_id=${companyId}` : ""}`;
		const { data: sectors } = await apiV1.get(apiUrl);
		return sectors.data;
	} catch (err) {
		throw new Error(err?.response?.data?.message);
	}
};

export const getUnitMeasures = async () => {
	try {
		const { data: units } = await apiV2.get(`quote/unit-of-measurement`);
		if (units.status) {
			return units.data;
		} else {
			return null;
		}
	} catch (err) {
		throw new Error(err?.response?.data?.message);
	}
};
